import React, { useEffect, useRef } from 'react';

import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';

const DeleteConfirmationModal = ({
	onClose,
	onConfirm,
	title = 'Delete Folder',
	description = 'Are you sure about deleting this folder?',
	isShowInput = false,
	inputValue,
	setInputValue,
	disabled = false
}) => {
	const inputRef = useRef(null);
	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.focus();
		}
		return () => {
			setInputValue && setInputValue('');
		};
	}, [inputRef]);
	return (
		<ModalContainer onCloseModal={onClose} className="sample-location-modal delete-modal">
			<div className="popup-wrapper">
				<div className="common-popup sample-location-modal delete-modal">
					<ModalHeader title={title} onClose={onClose} />
					<div className="common-popup-body">
						<p className="regular-14 gray_dark_01">{description}</p>
						{isShowInput && (
							<div className="from-group mt-3">
								<input
									name="folderName"
									type="text"
									placeholder={`Write the folder name to confirm`}
									value={inputValue}
									onChange={(e) => setInputValue(e.target.value)}
									ref={inputRef}
									autoComplete="off"
									// onCopy={(e) => e.preventDefault()}
									// onPaste={(e) => e.preventDefault()}
								/>
							</div>
						)}
					</div>
					<div className="modal-footer">
						<div className="footer-buttons text-right">
							<button className="button gray-outline size32" onClick={() => onClose()}>
								Cancel
							</button>
							<button
								className="button size32 ml-2 red"
								onClick={() => onConfirm()}
								disabled={disabled}
							>
								Confirm
							</button>
						</div>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default DeleteConfirmationModal;
